
import { colorTemperatureGlowStyle } from '@/utils/colorTemperature'

export default {
  name: 'ColorTemperatureSwatch',
  props: {
    kelvin: {
      type: Number,
      required: true,
    },
    size: {
      type: Number,
      default: 12,
    },
  },
  computed: {
    style() {
      return colorTemperatureGlowStyle(this.kelvin, this.size)
    },
  },
}
